import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "./pages/LoginView";
import SensorView from "./pages/SensorView";
import ChartView from "./pages/ChartView";
import TableView from "./pages/TableView";
import Navbar from "./components/Navbar";
import { validateToken, refreshAccessToken } from "./services/auth.service";

function App() {
  const [accessToken, setAccessToken] = useState(
    localStorage.getItem("accessToken") || ""
  );
  const [refreshToken, setRefreshToken] = useState(
    localStorage.getItem("refreshToken") || ""
  );

  useEffect(() => {
    // Si tenemos un Access Token pero ha expirado, intentamos renovarlo con el Refresh Token.
    if (accessToken) {
      validateToken(accessToken).catch(async () => {
        // Si la validación falla, intentamos obtener un nuevo Access Token.
        const newAccessToken = await refreshAccessToken();
        if (newAccessToken) {
          setAccessToken(newAccessToken);
        } else {
          // Si no podemos obtener un nuevo Access Token, removemos ambos tokens
          localStorage.removeItem("accessToken");
          localStorage.removeItem("refreshToken");
          setAccessToken("");
          setRefreshToken("");
        }
      });
    }
  }, [accessToken, refreshToken]);

  const isAuthenticated = !!accessToken;

  return (
    <Router>
      {isAuthenticated ? (
        <Navbar
          onLogout={() => {
            // Remover ambos tokens al hacer logout
            localStorage.removeItem("accessToken");
            localStorage.removeItem("refreshToken");
            setAccessToken("");
            setRefreshToken("");
          }}
        />
      ) : null}
      <Routes>
        <Route
          path="/login"
          element={
            isAuthenticated ? (
              <Navigate to="/sensores" />
            ) : (
              <Login
                onLogin={(tokens) => {
                  // Almacenar ambos tokens cuando el usuario inicie sesión
                  localStorage.setItem("accessToken", tokens.accessToken);
                  localStorage.setItem("refreshToken", tokens.refreshToken);
                  setAccessToken(tokens.accessToken);
                  setRefreshToken(tokens.refreshToken);
                }}
              />
            )
          }
        />
        <Route
          path="/sensores"
          element={isAuthenticated ? <SensorView /> : <Navigate to="/login" />}
        />
        <Route
          path="/graficos"
          element={isAuthenticated ? <ChartView /> : <Navigate to="/login" />}
        />
        <Route
          path="/tabla"
          element={isAuthenticated ? <TableView /> : <Navigate to="/login" />}
        />
        <Route
          path="/"
          element={<Navigate to={isAuthenticated ? "/sensores" : "/login"} />}
        />
      </Routes>
    </Router>
  );
}

export default App;
